// extracted by mini-css-extract-plugin
module.exports = {"main":"q_a_main__rES33","each":"q_a_each__Z7w7C","questions":"q_a_questions__2taF5","answer":"q_a_answer__3wWY4"};